module.exports = __webpack_public_path__ + "static/media/logo-mobile.11d6337a.svg";